(function($){
    $(document).ready(function() {


        $('.flex-four .accordion-title').on('click', function() {
            var key = $(this).attr('data-key');
            if ($(this).hasClass('active')) {
                $(this).removeClass('active');
                $(key).removeClass('open');
            } else {
                $(this).addClass('active');
                $(key).addClass('open');
            }
        });

    });
})
(jQuery);
